import React from 'react';
import VerificationInput from 'react-verification-input';

import Input from 'components/shared/Input/Input';
import Button from 'components/shared/Button/Button';

const PhoneLoginForm = ({ creds, setCreds, show, onSendCode, onConfirmCode }) => {
  return (
    <div className="flex flex-col justify-center align-middle">
      <Input
        label="Phone number"
        placeholder="e.g. (800) 555-0199"
        value={creds.phone}
        onChange={(e) => {
          e.persist();
          setCreds((ps) => ({ ...ps, phone: e.target.value }));
        }}
        className="!mb-8"
      />
      {!show.confirmCode && (
        <Button className="w-full" text="Send code" onClick={onSendCode} isLoading={show.loading} />
      )}
      {show.confirmCode && (
        <>
          <VerificationInput
            validChars="0-9"
            onChange={(e) => setCreds((ps) => ({ ...ps, code: e }))}
            onComplete={onConfirmCode}
            inputProps={{ autoComplete: 'one-time-code' }}
            placeholder=""
            classNames={{
              character: '!rounded-lg border-none text-primary-600 aspect-square bg-white shadow',
              characterSelected:
                '!rounded-lg border-none text-primary-600 aspect-square bg-primary-100 shadow border-b-2 border-b-solid border-b-primary-500',
              characterInactive:
                '!rounded-lg border-none text-primary-600 aspect-square bg-white shadow'
            }}
          />
          <Button
            text="Log in"
            onClick={onConfirmCode}
            isLoading={show.loading}
            className="mt-20 w-full"
          />
        </>
      )}
    </div>
  );
};

export default PhoneLoginForm;
